import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import FeaturedDrops from "@/components/FeaturedDrops";
import Worn from "@/components/Worn";
import Manifesto from "@/components/Manifesto";
import Studio from "@/components/Studio";
import Footer from "@/components/Footer";
import Countdown from "@/components/Countdown";
import SectionRail from "@/components/SectionRail";

export default function Home() {
    return (
        <main data-testid="home-page" className="bg-black text-white min-h-screen">
            <SectionRail />
            <Navbar />
            <Hero />
            <MarqueeStrip
                items={[
                    "Move With Purpose",
                    "Energy Matcher™",
                    "Drop 04",
                    "Elevated Essentials",
                    "Volume Limited",
                    "Built To Last",
                ]}
                variant="solid"
            />
            <FeaturedDrops />
            <Countdown />
            <MarqueeStrip
                items={[
                    "Effortless · Versatile · Confident",
                    "Energy Matcher",
                    "Drop 04",
                    "—",
                ]}
                variant="outline"
            />
            <Worn />
            <Studio />
            <Manifesto />
            <Footer />
        </main>
    );
}
